export const ALREADY_ENROLLED = 'ALREADY_ENROLLED';
export const INVALID_SALES_SUBSCRIPTION_STATUS = 'INVALID_SALES_SUBSCRIPTION_STATUS';
export const UNKNOWN_SALES_SUBSCRIPTION_STATUS = 'UNKNOWN_SALES_SUBSCRIPTION_STATUS'; // critsit follow-up: https://git.hubteam.com/HubSpot/Sequences/issues/4609
export const INVALID_EMAIL = 'INVALID_EMAIL';
export const CONTACT_NOT_FOUND = 'CONTACT_NOT_FOUND';
export const ENROLLED_IN_PROSPECTING_AGENT = 'ENROLLED_IN_PROSPECTING_AGENT';